import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const formatHourMinute = (isoTime: string): string => {
  if (!isoTime) return '';

  return new Date(isoTime).toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const isBlank = (val: any) =>
  val == null ||
  (typeof val === 'string' && val.trim() === '') ||
  (Array.isArray(val) && val.length === 0) ||
  (typeof val === 'object' && !Array.isArray(val) && Object.keys(val).length === 0);
